import {supabase} from '../supabase/supabase';

const SELLER_PROFILE_RESULT_COLUMNS=[
  'id',
  'business_name',
  'description',
  'location',
  'service_area',
  'availability',
  'category',
  'average_price',
  'profile_image',
  'profile_images',
  'shop_username',
  'min_order_window',
  'is_delivery_enabled',
  'delivery_charge',
  'weekly_availability',
  'blackout_dates',
  'pickup_weekly_availability',
  'pickup_blackout_dates',
  'policy_settings'
].join(',');

export const saveSellerProfile=async(sellerId,updates)=>{
  const {data,error}=await supabase
    .from('sellers')
    .update(updates)
    .eq('id',sellerId)
    .select('id')
    .maybeSingle();

  if (error) throw error;

  if (!data) {
    throw new Error('Seller profile was not updated. Confirm that you own this seller profile.');
  }

  return data;
};
